// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"c51cc93a","50":"f8b10fad","243":"2ceb75d5","499":"f96fecad","702":"1dde8d64","880":"087c08a6"}[chunkId] + ".chunk.js";
};